/* Ivevar speed: autoplay videos play only while they are on screen (saves battery, data and keeps scrolling smooth) */
(function () {
  if (window.__ivvSpeed || !('IntersectionObserver' in window)) return;
  window.__ivvSpeed = true;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i], v = e.target;
      v.__ivvVis = e.isIntersecting;
      if (e.isIntersecting) {
        if (v.__ivvHeld) {
          v.__ivvHeld = false;
          try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
        }
      } else if (!v.paused) {
        v.__ivvHeld = true;
        try { v.pause(); } catch (err) {}
      }
    }
  }, { rootMargin: '150px 0px' });

  function onPlay(ev) {
    var v = ev.target;
    if (v.__ivvVis === false) {
      v.__ivvHeld = true;
      try { v.pause(); } catch (err) {}
    }
  }

  function scan() {
    var vids = document.querySelectorAll('video[autoplay]:not([data-ivv-io])');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      v.setAttribute('data-ivv-io', '');
      v.addEventListener('play', onPlay);
      io.observe(v);
    }
  }

  /* When prices are shown in another currency, tell the customer that checkout is in USD (cart + product page) */
  function shownCurrency() {
    var el = document.querySelector('[bucks-currency]');
    var cur = el && el.getAttribute('bucks-currency');
    return cur ? String(cur).toUpperCase() : 'USD';
  }
  function setNote(box, before, cur, extraClass) {
    var note = box.querySelector(':scope > .ivv-usd-note');
    if (cur === 'USD') { if (note) note.remove(); return; }
    var text = 'Prices in ' + cur + ' are approximate. Checkout is in USD; your bank converts at its own rate.';
    if (!note) {
      note = document.createElement('p');
      note.className = 'ivv-usd-note' + (extraClass ? ' ' + extraClass : '');
      box.insertBefore(note, before);
    }
    if (note.textContent !== text) note.textContent = text;
  }
  function usdNotes() {
    var cur = shownCurrency();
    var spots = document.querySelectorAll('.scd__checkout, .sf-cart__buttons-container > .sf-cart__submit-controls, form[action*="/cart"] [name="checkout"]');
    for (var i = 0; i < spots.length; i++) {
      if (spots[i].parentNode) setNote(spots[i].parentNode, spots[i], cur, '');
    }
    var boxes = document.querySelectorAll('[data-ivv-codebox]');
    for (var j = 0; j < boxes.length; j++) {
      var b = boxes[j];
      if (b.hidden || !b.parentNode) continue;
      setNote(b.parentNode, b.nextSibling, cur, 'ivv-usd-note--pdp');
    }
  }

  /* Custom / personalised pieces: returns only for damage or defects (matches the Refund Policy) */
  function customReturns() {
    if (!document.querySelector('[data-ivv-custom]')) return;
    var spans = document.querySelectorAll('.shipping_icon_box_icon span');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (/return/i.test(s.textContent) && s.textContent !== 'Returns for damage or defects') {
        s.textContent = 'Returns for damage or defects';
        var img = s.parentNode && s.parentNode.querySelector('img');
        if (img) img.setAttribute('alt', 'Returns for damage or defects');
      }
    }
  }

  /* Code prices: show whole amounts ($1,920 not $1,920.00), same as the rest of the site */
  function trimDecimals() {
    var els = document.querySelectorAll('.ivv-code-pay .money, .ivv-cp .money, .ivv-pp .money, .ivv-pc .money, .ivv-gem-pr .money');
    for (var i = 0; i < els.length; i++) {
      var m = els[i];
      if (m.classList.contains('buckscc-converted')) continue;
      var t = m.textContent, n = t.replace(/[.,]00(?=\D*$)/, '');
      if (n !== t) m.textContent = n;
    }
  }

  function all() { scan(); usdNotes(); customReturns(); trimDecimals(); }
  var t = null;
  function later() { if (t) return; t = setTimeout(function () { t = null; all(); }, 250); }

  function start() {
    all();
    document.addEventListener('DOMContentLoaded', customReturns);
    window.addEventListener('load', all);
    try { new MutationObserver(later).observe(document.body, { childList: true, subtree: true }); } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
